// Слово-вариант блока fill_blank. Отдельным файлом по той же причине, что и
// YesNoOption: в прохождении это настоящая кнопка, в редакторе — статичная
// плашка, и фиктивной кнопки быть не должно.
import type { QuizOptionState } from '@teach/ui'
import { cn } from '@/lib/utils'
import { fillPillStyle } from './optionAppearance'

// Как чип в мобилке (quiz-block/styles.ts) и `.chip` плеера: пилюля высотой
// 38, рамка 1, semibold, тень по состоянию. Кегль задаёт ряд (`useFitChips`), 20 по умолчанию.
const CHIP =
  'inline-flex min-h-[38px] items-center justify-center whitespace-nowrap rounded-full border border-solid px-[0.8em] py-1.5 font-semibold leading-[1.2] transition-[border-color,background-color,color,box-shadow,transform] duration-200'

interface Props {
  word: string
  state: QuizOptionState
  disabled?: boolean
  /** Не передан — плашка статична (режим редактора). */
  onSelect?: () => void
}

export const FillBlankChip = ({ word, state, disabled, onSelect }: Props) =>
  onSelect ? (
    <button
      type="button"
      className={cn(CHIP, 'active:scale-[0.96]', state === 'incorrect' ? 'animate-oa-shake' : null)}
      style={fillPillStyle(state)}
      disabled={disabled}
      onClick={onSelect}
    >
      {word}
    </button>
  ) : (
    <span className={CHIP} style={fillPillStyle(state)}>
      {word}
    </span>
  )
